import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { HeaderWrap, LinksWrap, ProgressGroup, Button } from './styled'

import { HintText } from 'src/components/Typography'
import { SIGN_UP, PROFILE } from 'src/constants/routes'
import { ProgressBar } from 'src/components/ProgressBar'
import { QuestionIcon, UserLandingIcon } from 'src/components/Icons'
import { breakpoints } from 'src/styles/media'
import { useMedia } from 'src/hooks/useMedia'
import { SignIn } from 'src/components/SignIn'
import { WTFIsPumpkinPie } from 'src/components/WTFIsPumpkinPie'
import { iRootState } from 'src/store'
import { LogoLink } from 'src/components/LogoLink/LogoLink'

const stateSelector = (state: iRootState) => ({
  user: state.user.data,
})

interface HeaderProps {
  progress: number
  quizTitle: string
  isSignInOpen: boolean
  setIsSignInOpen: (isOpen: boolean) => void
  isSignInCloseAllowed: boolean
  isWTFOpen: boolean
  setIsWTFOpen: (isOpen: boolean) => void
}

export const Header: React.FC<HeaderProps> = ({
  progress,
  quizTitle,
  isSignInCloseAllowed,
  isSignInOpen,
  setIsSignInOpen,
  setIsWTFOpen,
  isWTFOpen,
}) => {
  const { push } = useHistory()

  const { user } = useSelector(stateSelector)

  const handleUserIconClick = () =>
    user
      ? push(user.profileComplete ? PROFILE : SIGN_UP)
      : setIsSignInOpen(true)

  const isDesktop = useMedia(breakpoints.desktop)

  return (
    <>
      <HeaderWrap>
        {isDesktop ? (
          <LogoLink />
        ) : (
          <Button onClick={() => setIsWTFOpen(true)}>
            <QuestionIcon />
          </Button>
        )}
        <ProgressGroup>
          <HintText>{quizTitle}</HintText>
          <ProgressBar progress={progress} />
        </ProgressGroup>
        <LinksWrap>
          {isDesktop && (
            <Button onClick={() => setIsWTFOpen(true)}>
              <QuestionIcon />
            </Button>
          )}
          <Button onClick={handleUserIconClick}>
            <UserLandingIcon />
          </Button>
        </LinksWrap>
      </HeaderWrap>
      <SignIn
        setOpenSignIn={setIsSignInOpen}
        openSignIn={isSignInOpen}
        isCloseAllowed={isSignInCloseAllowed}
      />
      <WTFIsPumpkinPie setOpenWTF={setIsWTFOpen} openWTF={isWTFOpen} />
    </>
  )
}
